// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * A class added to editors that can host a completer.
 */
export const COMPLETER_ENABLED_CLASS = 'jp-mod-completer-enabled';
/**
 * A class added to editors that have an active completer.
 */
export const COMPLETER_ACTIVE_CLASS = 'jp-mod-completer-active';
/**
 * A class added to editors that have a cursor at the beginning of the line.
 */
export const COMPLETER_LINE_BEGINNING_CLASS = 'jp-mod-at-line-beginning';
/**
 * Code editor services token.
 */
export const IEditorServices = new Token('@jupyterlab/codeeditor:IEditorServices', `A service for the text editor provider
  for the application. Use this to create new text editors and host them in your
  UI elements.`);
/**
 * Code editor cursor position token.
 */
export const IPositionModel = new Token('@jupyterlab/codeeditor:IPositionModel', `A service to handle an code editor cursor position.`);
//# sourceMappingURL=tokens.js.map